import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicComponent } from '../../dynamic-component/dynamic-component';
import { CommonModule } from '@angular/common';
import { DpLoaderComponent } from '../dp-loader/dp-loader.component';
import { CommonUtilService } from '../../services/common-util/common-util.service';

@Component({
  selector: 'dp-table',
  standalone: true,
  templateUrl: './dp-table.component.html',
  styleUrls: ['./dp-table.component.scss'],
  imports: [DynamicComponent, CommonModule, DpLoaderComponent],
})
export class DpTableComponent implements OnInit {
  @Input() isLoader?: boolean = false;
  @Input() dataTable!: any[];
  @Input() displayedColumns!: any[];
  @Input() componentMap: { [key: string]: any } = {};
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() rowData: EventEmitter<any> = new EventEmitter<any>();
  @Input() showCheckboxes: boolean = false;
  @Input() enableRowClick: boolean = false;
  @Input() columnConfs: { [key: string]: any } = {};
  @Input() type: string = '';
  @Output() selectedRowsChange = new EventEmitter<any[]>();
  selectedItems: any = [];
  constructor(private _CommonUtil: CommonUtilService) { }

  onCellClick(data: any) {
    this.cellClick.emit(data);
  }

  ngOnInit(): void {
    // Example of how to use delay callback function
    // this._CommonUtil.delayCallback(
    //   "loader",
    //   () => {
    //     if(this._CommonUtil.isValidArray(this.displayedColumns)) {
    //       this.isLoader = false;
    //     }
    //   },
    //   500
    // );
    // console.log(this.dataTable);
    // console.log(this.displayedColumns);
    // console.log(this.componentMap);
    
  }
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  sortTable(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.dataTable.sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      const isNumberA = !isNaN(+aValue);
      const isNumberB = !isNaN(+bValue);

      if (isNumberA && isNumberB) {
        aValue = +aValue;
        bValue = +bValue;
      } else {
        aValue = aValue?.toString().toLowerCase() || '';
        bValue = bValue?.toString().toLowerCase() || '';
      }
      if (aValue === null || aValue === undefined) return 1;
      if (bValue === null || bValue === undefined) return -1;

      if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
  }



  // Sorting logic for numeric values



  onCheckboxChange(event: any, row: any) {
    if (event.target.checked) {
      this.selectedItems.push(row);
    } else {
      this.selectedItems = this.selectedItems.filter(
        (selectedItem: any) => selectedItem !== row
      );
    }
    this.selectedRowsChange.emit(this.selectedItems);
  }

  onRowClick(event: MouseEvent, rowData: any) {
    event.stopPropagation()
    this.rowData.emit(rowData);
  }

  onHeaderCheckboxChange(event: any) {
    if (event.target.checked) {
      this.selectedItems = [...this.dataTable];
    } else {
      this.selectedItems = [];
    }
    this.selectedRowsChange.emit(this.selectedItems);
  }
  isSelected(row: any) {
    return this.selectedItems.includes(row);
  }
}
